import { type FC } from 'react';

import {
  AuthenticatedUserProvider,
  type AuthenticatedUserProviderProps,
} from './AuthenticatedUserProvider';

export interface UserProviderProps extends AuthenticatedUserProviderProps {}

export const UserProvider: FC<UserProviderProps> = ({ children, ...props }) => (
  <AuthenticatedUserProvider {...props}>{children}</AuthenticatedUserProvider>
);
